import { createContext } from 'react';

export const AbilityContext = createContext({});

// TODO: Fix this component

type Props = any;

// export const Can = createContextualCan(AbilityContext.Consumer as Consumer<AnyAbility>);
export const Can = ({ children }: Props) => <>{children}</>;
